import React, { useState } from "react";
import { NavLink} from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { TbHomeHand } from "react-icons/tb";
import Banner from "./Banner";
import '../sass/layout/_header.scss';
import '../sass/base/_header_typo.scss';

export default function Header() {
    const [nav, setNav] = useState(false)

    const handleClick = () => {
        setNav(!nav)
    }
    return (
        <header className='heading-page'>
            <div className="heading_childs">
                <div className="logo">
                    <h1>EH.</h1>
                    <span className="logo_para">
                        Evanescence Hypnose.
                    </span>
                </div>
                <nav className={nav ? 'navigation active' : 'navigation'}>
                    <ul>
                        <li>
                            <NavLink
                                to="/about"
                                className={(nav) => (nav.isActive ? 'nav-active' : '')}
                            >
                                About
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to='/contact'
                                className={(nav) => (nav.isActive ? 'nav-active' : '')}
                            >
                                Contact
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/"
                                aria-label="Home"
                                className={(nav) => (nav.isActive ? 'nav-active' : '')}
                            >
                                <TbHomeHand />
                            </NavLink>
                        </li>
                    </ul>
                </nav>
                <div className='toggle' onClick={handleClick}>
                    {nav ? (<FaTimes size={20} style={{ color: '#333' }} />) : (<FaBars size={20} style={{ color: '#333' }} />)}
                </div>
            </div>
            <Banner />
        </header>
    )
}
